export default __webpack_public_path__ + "static/media/cp_geo_so.15e9221c.svg";